
/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'arrow': {
    width: 20,
    height: 20,
    viewBox: '0 0 25 20',
    data: '<path d="M7.41 14L12 9.42L16.59 14L18 12.59L12 6.59L6 12.59L7.41 14Z"/>'
  }
})
